module.exports = __webpack_public_path__ + "img/_history_log_primary.e36f5698.svg";